import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@headlessui/react';
import LargeModal from '../../components/Modal/LargeModal';

const GeneralLabelModal = ({
                                  open, onClose, data, exportFunction, isMetric, orderId
                              }) => {

    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const [lineValue, setLineValue] = useState([]);
    const [boxValue, setBoxValue] = useState([]);

    useEffect(() => {
        // Initialize values with 0s, matching the length of dataArray
        setLineValue(Array.from({ length: data.length }, (_, i) => i + 1));
        setBoxValue(new Array(data.length).fill(0));
    }, [data]);

    function handleLineValueChange(event, sampleIndex) {
        setLineValue(prevValues => {
            const updated = [...prevValues];
            updated[sampleIndex] = String(event.target.value);
            return updated;
        });
    }

    function handleBoxValueChange(event, sampleIndex) {
        setBoxValue(prevValues => {
            const updated = [...prevValues];
            updated[sampleIndex] = String(event.target.value);
            return updated;
        });
    }

    return (
        <LargeModal open={open} setOpen={onCloseButtonClickHandler}>
            <div>
                <Tab.Group>
                    <Tab.Panels>
                        <h2 className="font-bold pb-4">Order Details</h2>

                        <div className="flex flex-row w-full text-white text-sm pt-4 h-16">
                            <div className="w-[7%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Line #</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Glass Type</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Performance</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Drawing</h2>
                            </div>
                            <div className="w-[30%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Product</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Note</h2>
                            </div>
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Quantity & Sample Size</h2>
                            </div>
                            <div className="w-[8%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Box #</h2>
                            </div>
                        </div>

                        {data.map((item, sampleIndex) => (
                            <div className="flex flex-row w-full h-auto text-xs">
                                <div className="w-[7%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Line #"
                                        onChange={(e) => handleLineValueChange(e, sampleIndex)}
                                        value={lineValue[sampleIndex]}
                                    />
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.family}</h2>
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <div className="flex flex-col">
                                        <h2>VLT: {item.description_visible}</h2>
                                        <h2>LSG: {item.light_solar_gain_ration}</h2>
                                        <h2>SC: {item.shading_coefficient}</h2>
                                        <h2>SHGC: {item.solar_heat_gain_coefficient}</h2>
                                        <h2>Summer U: {isMetric ? item.u_value_summer_metric : item.u_value_summer}</h2>
                                        <h2>Winter U: {isMetric ? item.u_value_solar_metric : item.u_value_solar}</h2>
                                        <h2>R Out: {item.reflectance_out}</h2>
                                    </div>
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.drawing}</h2>
                                </div>
                                <div className="w-[30%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white whitespace-pre-line p-2">
                                    <h2 className="text-center">
                                        {data.isMetric && (
                                            <>
                                                <div>{item.top_line_metric}</div>
                                                {item.spec_metric.map((line, index) => (
                                                    <div>{line}</div>
                                                ))}
                                            </>
                                        )}
                                        {!data.isMetric && (
                                            <>
                                                <div>{item.top_line_imp}</div>
                                                {item.spec_imp.map((line, index) => (
                                                    <div>{line}</div>
                                                ))}
                                            </>
                                        )}
                                    </h2>
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.note}</h2>
                                </div>
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.quantity}x</h2>
                                    <h2 className="text-center pl-2">{item.sampleSize}</h2>
                                </div>
                                <div className="w-[8%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Box #"
                                        onChange={(e) => handleBoxValueChange(e, sampleIndex)}
                                        value={boxValue[sampleIndex]}
                                    />
                                </div>
                                {/* Designer Function Part End */}
                            </div>
                        ))}
                    </Tab.Panels>
                </Tab.Group>
            </div>
            <div className="flex flex-row justify-end pt-2">
                <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    onClick={() => exportFunction(lineValue, boxValue, orderId)}
                >
                    Submit
                </button>
            </div>
        </LargeModal>
    );
};

GeneralLabelModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    exportFunction: PropTypes.func.isRequired,
    isMetric: PropTypes.bool.isRequired,
    orderId: PropTypes.string.isRequired,
};

export default GeneralLabelModal;
